import usersMenu from "./users";
import logoutMenu from "./logout";
import accountInfoMenu from "./account-info";
import { currentUserRole } from "../store/constant";
// import pages from './pages';
// import utilities from './utilities';
// import other from './other';

// ==============================|| MENU ITEMS ||============================== //

const roleToggle = {
  id: "roleToggle",
  title: "Admin Role",
  type: "toggle",
};

const refreshHubspotButton = {
  id: "refreshHubspotButton",
  title: "Refresh HubSpot Data",
  type: "button",
};

let items = [];
if (currentUserRole === "Admin") {
  items = [refreshHubspotButton, logoutMenu];
} else {
  items = [refreshHubspotButton, logoutMenu];
}

const menuItems = {
  items: items,
};

export default menuItems;
